import { RadioGroup as RadioGroupPrimitive } from 'radix-ui';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

export interface RadioGroupIndicatorProps {
  className?: string;
}

/**
 * The radio dot. Render it inside an item to show one; omit it for an item
 * that reads as a plain selectable card while keeping the radio role.
 *
 * Force-mounted so the dot can transition out on deselection instead of
 * unmounting instantly.
 */
export function RadioGroupIndicator({ className }: RadioGroupIndicatorProps) {
  return (
    <RadioGroupPrimitive.Indicator forceMount asChild>
      <span className={cn(css.indicator, className)} aria-hidden>
        <span className={css.indicatorInner} />
      </span>
    </RadioGroupPrimitive.Indicator>
  );
}
